import { z } from 'zod';
import { servicesProviderPricingFlatFeeSchema, servicesProviderPricingFlatFeeDtoSchema } from '../ServicesProviderPricing.js';
import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Enums
// ============================================================================
const TempTagIssuer = {
    EKHO: 'EKHO',
    SELF: 'SELF',
};
const tempTagIssuerValues = [TempTagIssuer.EKHO, TempTagIssuer.SELF];
const TempTagIssuerSchema = z.enum(tempTagIssuerValues);
const TempTagIssuanceWorkflow = {
    BOOKLET: 'BOOKLET',
    EXTERNAL_PORTAL: 'EXTERNAL_PORTAL',
    INTERNAL_PORTAL: 'INTERNAL_PORTAL',
    EKHO_TEMP_TAG_PACKET: 'EKHO_TEMP_TAG_PACKET',
};
const tempTagIssuanceWorkflowValues = [
    TempTagIssuanceWorkflow.BOOKLET,
    TempTagIssuanceWorkflow.EXTERNAL_PORTAL,
    TempTagIssuanceWorkflow.INTERNAL_PORTAL,
    TempTagIssuanceWorkflow.EKHO_TEMP_TAG_PACKET,
];
const TempTagIssuanceWorkflowSchema = z.enum(tempTagIssuanceWorkflowValues);
// ============================================================================
// Pricing Schemas
// ============================================================================
const tempTagServicePricingSchema = servicesProviderPricingFlatFeeSchema;
const tempTagServicePricingDtoSchema = servicesProviderPricingFlatFeeDtoSchema;
// ============================================================================
// Core Schema
// ============================================================================
const tempTagServiceConfigSchema = serviceConfigSchema.extend({
    issuer: TempTagIssuerSchema,
    issuanceWorkflow: TempTagIssuanceWorkflowSchema,
    pricing: z.array(tempTagServicePricingSchema),
});
// ============================================================================
// DTO Schema
// ============================================================================
const tempTagServiceConfigDtoSchema = serviceConfigSchema.extend({
    issuer: TempTagIssuerSchema,
    issuanceWorkflow: TempTagIssuanceWorkflowSchema,
    pricing: z.array(tempTagServicePricingDtoSchema),
});

export { TempTagIssuanceWorkflow, TempTagIssuanceWorkflowSchema, TempTagIssuer, TempTagIssuerSchema, tempTagIssuanceWorkflowValues, tempTagIssuerValues, tempTagServiceConfigDtoSchema, tempTagServiceConfigSchema, tempTagServicePricingDtoSchema, tempTagServicePricingSchema };
//# sourceMappingURL=TempTagServiceConfig.js.map
